import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-dom-ria',
  templateUrl: './dom-ria.component.html',
  styleUrls: ['./dom-ria.component.scss']
})
export class DomRiaComponent {
  menuOpen = false;
  reviews = [
    { text: 'dom_page.testimonials_1_text', author: 'dom_page.testimonials_1_author' },
    { text: 'dom_page.testimonials_2_text', author: 'dom_page.testimonials_2_author' }
  ];
  toggleMenu(): void { this.menuOpen = !this.menuOpen; }
  scrollTo(id: string): void {
    const el = document.getElementById(id);
    if (el) { el.scrollIntoView({ behavior: 'smooth' }); }
    if (this.menuOpen) { this.toggleMenu(); }
  }

  protected readonly environment = environment;
}
